import { get } from "lodash";
import moment from "moment";
import { isMajor } from "utils/helpers/date";
import { parentsHaveDifferentSocialRegimes } from "utils/helpers/miltisRelatedPersonChild";
import * as yup from "yup";

const getFormValuesFromYupTest = (testContext) => {
  const from = get(testContext, "from", []);
  for (let index = from.length - 1; index >= 0; index -= 1) {
    const entryValue = get(from, [index, "value"]);
    if (
      entryValue &&
      Object.prototype.hasOwnProperty.call(entryValue, "spouse") &&
      Object.prototype.hasOwnProperty.call(entryValue, "children")
    ) {
      return entryValue;
    }
  }
  return null;
};

const validation = (errors, { adherentSocialRegime } = {}) => {
  return yup.object().shape({
    spouse: yup
      .object()
      .shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .max(isMajor, errors.RADIANCE.SPOUSE_AGE)
              .min(
                moment().subtract(100, "year").startOf("year"),
                errors.RADIANCE.SPOUSE_AGE,
              )
              .required(errors.REQUIRED),
          }),
          socialRegime: yup
            .string()
            .typeError(errors.REQUIRED)
            .required(errors.REQUIRED),
        }),
      })
      .nullable()
      .default(undefined),
    children: yup.array().of(
      yup.object().shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .min(
                moment().subtract(27, "year").startOf("year"),
                errors.RADIANCE.CHILD_AGE,
              )
              .max(moment(), errors.RADIANCE.CHILD_AGE)
              .required(errors.REQUIRED),
          }),
          socialRegime: yup
            .string()
            .nullable()
            .test(
              "required-when-parents-differ",
              errors.REQUIRED,
              function (value) {
                const formValues = getFormValuesFromYupTest(this);
                const spouse = get(formValues, "spouse");
                if (
                  !parentsHaveDifferentSocialRegimes({
                    adherentSocialRegime,
                    spouseSocialRegime: get(
                      spouse,
                      "identity.socialRegime",
                    ),
                    hasSpouse: !!spouse,
                  })
                ) {
                  return true;
                }
                return !!value;
              },
            ),
        }),
      }),
    ),
  });
};

export default validation;
